import { Fragment, useState, useEffect, useCallback } from 'react';
import { useStore } from '../../hooks/store';
import cx from 'classnames';
import useHttp from '../../hooks/http';
import getApiToken from '../../utils/getApiToken';
import { setUrlHash } from '../../utils/setUrlHash';
import moment from 'moment-timezone';

import { Button, AltTimesMessage } from '../../styles/calendar.js';

const apiToken = getApiToken();

const CrossSell = (props) => {
    const [state, dispatch] = useStore();
    const { isLoading, data, error, sendRequest, clear } = useHttp();
    const { tickets, dateContext, selectedDate, selectedDay, selectedTime, eventDates, weekdaysShort, months, events, eventTitles,
        totalTickets, ticketTypeData, deluxeTickets, btsTickets, checkParking, section, calendarType, showCalendarModal } = state;
    const [hasDeluxe, setHasDeluxe] = useState(false);
    const [hasBTS, setHasBTS] = useState(false);
    const [deluxeDates, setDeluxeDates] = useState([]);
    const [btsDates, setBtsDates] = useState([]);

    useEffect (() => {
        // checkDeluxe();
        // checkBTS();
    }, []);

    useEffect (() => {
        if (deluxeDates.length > 0) {
            if (deluxeDates.includes(selectedDay)) setHasDeluxe(true);
            else setHasDeluxe(false);
        } else if (btsDates.length > 0) {
            if (btsDates.includes(selectedDay)) setHasBTS(true);
            else setHasBTS(false);
        }
    }, [selectedDay]);

    const checkDeluxe = () => {
        var dDates = [];
        deluxeTickets.forEach(dT => {
            dT.forEach(d => {
                let date = moment.utc(d.time).format('Y-M-D');
                // dDates[date] = d;
                if (!dDates.includes(date)) {
                    dDates.push(date);
                }
            });
        });
        // console.log('dDates', dDates);
        // setDeluxeDates(Object.keys(dDates));
        setDeluxeDates(dDates);
    }
    const checkBTS = () => {
        // console.log('checkBTS');
        var bDates = {};
        btsTickets.forEach(btsT => {
            btsT.forEach(b => {
                let date = moment.utc(b.time).format('Y-M-D');
                bDates[date] = b;
            });
        });
        // console.log(Object.keys(btsDates));
        setBtsDates(Object.keys(bDates));
    }
    const openDeluxe = () => {
        // var ticketQuantities = [...tickets.tq];
        // console.log('tickets', tickets);
        const adultIndex = tickets.findIndex(t => t.slug === 'adult');
        const childIndex = tickets.findIndex(t => t.slug === 'child');
        const familyIndex = tickets.findIndex(t => t.slug === 'family');
        const family1Index = tickets[familyIndex]['qty'].findIndex(t => t.slug === 'family_2_2');
        const family2Index = tickets[familyIndex]['qty'].findIndex(t => t.slug === 'family_1_3');
        const adultPackageIndex = tickets.findIndex(t => t.slug === 'adult-package');
        const childPackageIndex = tickets.findIndex(t => t.slug === 'child-package');

        var transferTicketNums = {
            adult: tickets[adultIndex].qty + (tickets[familyIndex]['qty'][family1Index].qty * 2) + (tickets[familyIndex]['qty'][family2Index].qty) + tickets[adultPackageIndex].qty,
            child: tickets[childIndex].qty + (tickets[familyIndex]['qty'][family1Index].qty * 2) + (tickets[familyIndex]['qty'][family2Index].qty * 3) + tickets[childPackageIndex].qty,
        };
        dispatch('SET', { ticketQty: {...transferTicketNums} });
        // console.log('transferTicketNums', transferTicketNums);
        setUrlHash('deluxe-tour');
        dispatch('SET', {
            changeType: true,
            fetchMonth: true,
            section: 'deluxe-tour',
            isCrossSell: true,
            showCalendar: true,
            selectedTime: null,
            selectedEvent: null
        });
    }
    const openBTS = () => {
        setUrlHash('behind-the-seams');
        dispatch('SET', {
            changeType: true,
            fetchMonth: true,
            section: 'behind-the-seams',
            isCrossSell: true,
            showCalendar: true,
            selectedTime: null,
            selectedEvent: null
        });
    }

    return (
        <Fragment>
            <AltTimesMessage>No times available for your selected day. If other tour types have available times, the buttons will be clickable below.</AltTimesMessage>
            <Button className={cx({
                'name': true,
                'disabled': !hasDeluxe
            })} onClick={openDeluxe}>
                {hasDeluxe && <i className="fas fa-check"></i>}
                Deluxe Tours
            </Button>
            <Button className={cx({
                'name': true,
                'disabled': !hasBTS
            })} onClick={openBTS}>
                {hasBTS && <i className="fas fa-check"></i>}
                Behind the Seams
            </Button>
        </Fragment>
    );
}

export default CrossSell;
